import { format as formatSql, SqlLanguage } from 'sql-formatter';
import { WarehouseType } from '../../types';

const GENERIC_SQL_LANGUAGE: SqlLanguage = 'sql';

export const WAREHOUSE_SQL_LANGUAGES: Record<WarehouseType, SqlLanguage> = {
  databricks: 'spark',
  snowflake: 'snowflake',
  bigquery: 'bigquery',
  redshift: 'redshift',
  postgres: 'postgresql',
  athena: 'trino',
  fabric: 'transactsql',
  clickhouse: GENERIC_SQL_LANGUAGE,
  dremio: GENERIC_SQL_LANGUAGE,
};

const formatWithLanguage = (code: string, language: SqlLanguage): string =>
  formatSql(code, { language, tabWidth: 2, keywordCase: 'upper' });

export const formatSqlCode = (
  code: string,
  warehouseType?: WarehouseType,
): string => {
  if (!code || !code.trim()) return code;

  const language = warehouseType
    ? WAREHOUSE_SQL_LANGUAGES[warehouseType]
    : GENERIC_SQL_LANGUAGE;

  try {
    return formatWithLanguage(code, language);
  } catch {
    if (language === GENERIC_SQL_LANGUAGE) return code;
  }

  try {
    return formatWithLanguage(code, GENERIC_SQL_LANGUAGE);
  } catch {
    return code;
  }
};
